// extracted by mini-css-extract-plugin
export default {"heading":"LandscapeIndicatorContributionEditTemplate_heading__Ut5xP","buttonLink":"LandscapeIndicatorContributionEditTemplate_buttonLink__Xmx3u"};